import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import i18n from '../../../common/i18n';
import Reveal from '../commons/Reveal';
import SectionHeading from '../commons/SectionHeading';
import StatsCarousel from '../commons/StatsCarousel';
import StatCard from '../commons/StatCard';
import { HOME_STATS } from '../commons/homeData';
import {
  ABOUT_GRID_COLUMNS, bodyFont, CARD_RADIUS, homeColors, sectionContentSx, sectionPadding,
  shadowSoftStrong, STAT_CARD_HEIGHT, titleFont,
} from '../style/homeStyles';

const QuienesSomos = ({ isMobile }) => (
  <Box
    component="section"
    sx={{
      backgroundColor: isMobile ? homeColors.bg : homeColors.white,
      padding: sectionPadding(isMobile),
      textAlign: 'left',
    }}
  >
    <Box sx={sectionContentSx}>
      <SectionHeading
        eyebrow={i18n.homeAboutEyebrow}
        title={i18n.homeAboutTitle}
        titleFontSize={isMobile ? 28 : 48}
      />

      {/* Mobile: propósito arriba y métricas en carrusel. Desktop: cuatro columnas,
          con el propósito más ancho que las métricas. */}
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : ABOUT_GRID_COLUMNS,
        gap: isMobile ? 0 : '16px',
        alignItems: 'stretch',
      }}
      >
        <Reveal sx={{ height: '100%' }}>
          <Box sx={{
            position: 'relative',
            overflow: 'hidden',
            padding: isMobile ? '24px 26px 26px' : '26px 28px',
            borderRadius: CARD_RADIUS,
            minHeight: isMobile ? 170 : STAT_CARD_HEIGHT,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: isMobile ? 'space-between' : 'flex-start',
            background: 'linear-gradient(140deg, #FFD9E7 0%, #FCEAF1 100%)',
            boxShadow: isMobile
              ? '0 1px 0 rgba(31,27,29,0.02), 0 14px 28px -18px rgba(218,0,103,0.22)'
              : shadowSoftStrong,
          }}
          >
            <Typography
              component="span"
              sx={{
                position: 'relative',
                fontFamily: titleFont,
                fontWeight: 700,
                fontSize: isMobile ? 42 : 48,
                lineHeight: 0.95,
                letterSpacing: '-0.04em',
                color: homeColors.pink,
              }}
            >
              {i18n.homeAboutPurposeLabel}
            </Typography>
            <Typography
              component="p"
              sx={{
                position: 'relative',
                marginTop: isMobile ? '14px' : 'auto',
                marginBottom: isMobile ? 0 : 'auto',
                paddingTop: isMobile ? 0 : '14px',
                maxWidth: 320,
                fontFamily: bodyFont,
                fontWeight: isMobile ? 500 : 400,
                fontSize: isMobile ? 14 : 20,
                lineHeight: 1.45,
                color: homeColors.ink2,
              }}
            >
              {i18n.homeAboutPurposeText}
            </Typography>
            <Box
              aria-hidden="true"
              sx={{
                position: 'absolute',
                width: 110,
                height: 110,
                borderRadius: '50%',
                backgroundColor: 'rgba(255,255,255,0.4)',
                top: -32,
                right: -32,
                pointerEvents: 'none',
              }}
            />
          </Box>
        </Reveal>

        {/* En desktop las métricas son tres columnas más de la misma grilla. */}
        {!isMobile && HOME_STATS.map((stat, index) => (
          <Reveal key={stat.id} delay={100 + index * 80} sx={{ height: '100%' }}>
            <StatCard value={stat.value} label={stat.label} isDesktop />
          </Reveal>
        ))}
      </Box>

      {/* En mobile van en un carrusel arrastrable. */}
      {isMobile && (
        <Reveal delay={100}>
          <StatsCarousel stats={HOME_STATS} />
        </Reveal>
      )}
    </Box>
  </Box>
);

QuienesSomos.propTypes = {
  isMobile: PropTypes.bool,
};

QuienesSomos.defaultProps = {
  isMobile: false,
};

export default QuienesSomos;
